import React from 'react';
import { Button } from 'antd';
import {
  bool, func, node, number,
} from 'prop-types';

const ButtonWrapper = ({
  children,
  isVisible = true,
  loadMenuData,
  onMouseLeave = () => {},
  onMouseMove = () => {},
  showDrawer,
  toggleKey,
}) => isVisible && (
  <Button
    className="top-menu-field-groups__toggle-btn"
    onClick={() => showDrawer(toggleKey)}
    onMouseOver={loadMenuData}
    onMouseMove={onMouseMove}
    onMouseLeave={onMouseLeave}
    type="link"
  >
    {children}
  </Button>
);

ButtonWrapper.propTypes = {
  children: node.isRequired,
  isVisible: bool,
  loadMenuData: func.isRequired,
  onMouseLeave: func,
  onMouseMove: func,
  showDrawer: func.isRequired,
  toggleKey: number.isRequired,
};

export default ButtonWrapper;
